import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService, notCloseMessageOptions } from '../../../../../core';
import { DatepickerComponent } from '../../../../../shared';
import { PessoaIPI } from '../pessoa-ipi';

@Component({
    selector: 'sgt-pessoa-ipi-form',
    templateUrl: './pessoa-ipi-form.component.html',
    styleUrls: ['./pessoa-ipi-form.component.less']
})
export class PessoaIPIFormComponent {
    @Input() entity: PessoaIPI;
    @Input() canEdit = true;

    @ViewChild('form') form: NgForm;
    @ViewChild('optanteIPIDataDatepicker') optanteIPIDataDatepicker: DatepickerComponent;

    constructor(private messageService: MessageService) { }

    /** Verifica se o form e suas informações está válidas */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        // Form válido
        if (!this.form.valid) {
            this.messageService.warning('Informe corretamente todos os campos de IPI (Imposto sobre Produtos Industrializados) da empresa', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
